import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import AuthLayout from '~/components/organisms/auth/AuthLayout/AuthLayout';
import SignInForm from '~/components/organisms/auth/SignInForm';
import { Text } from '~/components/ui/text';
import { getIsMobile } from '~/store/reducers/app/selectors';

export default function SignIn() {
  const { t } = useTranslation();

  const isMobile = useSelector(getIsMobile);

  return (
    <AuthLayout>
      <Text variant={isMobile ? 'h2' : 'h1.5'} sx={{ textAlign: 'center' }}>
        {t('signIn:title')}
      </Text>
      <Text variant="subheader" sx={{ textAlign: 'center' }}>
        {t('signIn:subtitle')}
      </Text>
      <SignInForm />
    </AuthLayout>
  );
}
